var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('g',[_c('polygon',{attrs:{"points":"17.73 12 9.79 4.02 7.05 4.02 7.05 19.98 9.79 19.98 17.73 12"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }